/**
 * Main Application Entry Script
 * Bundles ES modules and exposes WTEModules globally for seamless interaction.
 */

import { authModule } from "./modules/auth.js";
import { menuModule } from "./modules/menu.js";
import { orderModule, ORDER_STATUSES } from "./modules/orders.js";
import { subscriptionsModule, SUBSCRIPTION_PLANS } from "./modules/subscriptions.js";
import { authFeature } from "./features/auth.js";
import { providerFeature } from "./features/provider.js";
import { clientFeature } from "./features/client.js";
import { ordersFeature } from "./features/orders.js";
import { adminFeature } from "./features/admin.js";
import { searchFeature } from "./features/search.js";
import { subscriptionsFeature } from "./features/subscriptions.js";
import {
  getMarketRule,
  calculateOrderTax,
  formatCurrency,
  TARGET_MARKET_RULES,
  COUNTRY_LAUNCH_RESTRICTIONS,
  SUPPORTED_LAUNCH_COUNTRIES,
  getLaunchCountryPolicy,
  normalizePhoneNumber,
  normalizeProviderTimezone,
  isSupportedLaunchCountry,
  isProviderOpenNow,
  isValidE164Phone
} from "./modules/marketCompliance.js";
import { i18nService, TRANSLATIONS } from "./modules/i18n.js";

window.WTEModules = {
  auth: authModule,
  menu: menuModule,
  orders: {
    instance: orderModule,
    statuses: ORDER_STATUSES
  },
  subscriptions: {
    instance: subscriptionsModule,
    plans: SUBSCRIPTION_PLANS
  },
  marketCompliance: {
    getMarketRule,
    calculateOrderTax,
    formatCurrency,
    rules: TARGET_MARKET_RULES,
    supportedLaunchCountries: SUPPORTED_LAUNCH_COUNTRIES,
    getLaunchCountryPolicy,
    normalizePhoneNumber,
    normalizeProviderTimezone,
    isSupportedLaunchCountry,
    isProviderOpenNow
  },
  i18n: {
    instance: i18nService,
    translations: TRANSLATIONS,
    t: (key, fallback) => i18nService.t(key, fallback),
    setLanguage: (lang) => i18nService.setLanguage(lang),
    getLanguage: () => i18nService.getLanguage()
  },
  features: {
    auth: authFeature,
    provider: providerFeature,
    client: clientFeature,
    orders: ordersFeature,
    admin: adminFeature,
    search: searchFeature,
    subscriptions: subscriptionsFeature
  }
};

window.authModule = authModule;
window.marketComplianceService = {
  TARGET_MARKET_RULES,
  COUNTRY_LAUNCH_RESTRICTIONS,
  SUPPORTED_LAUNCH_COUNTRIES,
  getMarketRule,
  calculateOrderTax,
  formatCurrency,
  getLaunchCountryPolicy,
  normalizePhoneNumber,
  normalizeProviderTimezone,
  isSupportedLaunchCountry,
  isProviderOpenNow,
  isValidE164Phone
};
window.i18nService = i18nService;
window.TRANSLATIONS = TRANSLATIONS;
window.WTEFeatures = window.WTEModules.features;
window.WTEArchitecture = {
  bootstrap: {
    manifest: window.__WTE_RUNTIME_FEATURES__ || {}
  },
  services: {
    auth: window.authService || null,
    marketCompliance: window.marketComplianceService,
    i18n: window.i18nService
  },
  features: window.WTEFeatures
};

// Auto-initialize i18n translations on DOM load
function initI18nDOM() {
  i18nService.applyTranslations();

  // Wire up language selector if present in DOM
  const langSelect = document.getElementById("languageSelector");
  if (langSelect) {
    langSelect.value = i18nService.getLanguage();
    langSelect.addEventListener("change", (e) => {
      i18nService.setLanguage(e.target.value);
    });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initI18nDOM);
} else {
  initI18nDOM();
}

console.log("[WTEModules] ES modules & I18n service successfully initialized.");
